import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '../ui/card';
import { getStageDurations } from '../../services/api';
import { fmtDuration } from './stages';
import { toast } from 'sonner';
import { BarChart3 } from 'lucide-react';

const BottleneckReport = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getStageDurations()
      .then((res) => setRows(res.data || []))
      .catch(() => toast.error('Failed to load bottleneck report'))
      .finally(() => setLoading(false));
  }, []);

  const withData = rows.filter((r) => r.count > 0);
  const maxAvg = withData.length ? Math.max(...withData.map((r) => r.avg_ms)) : 0;

  return (
    <div className="space-y-4" data-testid="bottleneck-report">
      <Card><CardContent className="p-4">
        <p className="font-medium flex items-center gap-2"><BarChart3 size={16} className="text-accent" />Average time per stage</p>
        <p className="text-sm text-muted-foreground">Across all jobs that have completed each stage — the longest average is your bottleneck</p>
      </CardContent></Card>

      <Card><CardContent className="p-4">
        {loading ? (
          <div className="flex items-center justify-center h-32"><div className="animate-spin rounded-full h-8 w-8 border-2 border-accent border-t-transparent" /></div>
        ) : withData.length === 0 ? (
          <p className="text-center text-muted-foreground py-8">No completed stages yet — advance a few jobs to see timings.</p>
        ) : (
          <div className="space-y-3">
            {rows.map((r) => {
              const pct = maxAvg > 0 ? Math.round((r.avg_ms / maxAvg) * 100) : 0;
              const isMax = r.count > 0 && r.avg_ms === maxAvg && maxAvg > 0;
              return (
                <div key={r.key} data-testid={`bottleneck-row-${r.key}`}>
                  <div className="flex items-center justify-between text-sm mb-1">
                    <span className={isMax ? 'font-semibold text-red-600' : ''}>{isMax ? '⚠ ' : ''}{r.label} <span className="text-xs text-muted-foreground">({r.count} done)</span></span>
                    <span className={`font-mono text-xs ${isMax ? 'text-red-600 font-semibold' : 'text-muted-foreground'}`}>{r.count > 0 ? fmtDuration(r.avg_ms) : '—'}</span>
                  </div>
                  <div className="h-3 bg-muted rounded-full overflow-hidden">
                    <div className={`h-full rounded-full transition-all ${isMax ? 'bg-red-500' : 'bg-accent'}`} style={{ width: (r.count > 0 ? Math.max(pct, 4) : 0) + '%' }} />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </CardContent></Card>
    </div>
  );
};

export default BottleneckReport;
